import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid, Box, Typography } from "@mui/material";

interface Props {
  text?: string;
  onYes: () => void;
  onCancel: () => void;
}

export default function ConfirmComponent({
  text,
  onYes,
  onCancel,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {text || t("general.areYouSure")}
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }} >
          <Button
            variant="contained"
            color="success"
            onClick={onYes}
            fullWidth
          >
            {t("general.yes")}
          </Button>
        </Grid>
        <Grid size={{ xs: 6 }} >
          <Button
            variant="outlined"
            color="error"
            onClick={onCancel}
            fullWidth
          >
            {t("general.no")}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
